import { render, staticRenderFns } from "./CommissionsCurrentList.vue?vue&type=template&id=6000aced&scoped=true"
import script from "./CommissionsCurrentList.vue?vue&type=script&lang=js"
export * from "./CommissionsCurrentList.vue?vue&type=script&lang=js"
import style0 from "./CommissionsCurrentList.vue?vue&type=style&index=0&id=6000aced&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6000aced",
  null
  
)

export default component.exports